import { Pipe, PipeTransform } from '@angular/core';
import { formatPhoneNumber } from 'app/_utils/phone-format';

@Pipe({ name: 'phone' })
export class PhonePipe implements PipeTransform {
  transform(value: string | null | undefined): string | null | undefined {
    return formatPhoneNumber(value);
  }
}
